import React, {Component} from 'react';
import {Helmet} from 'react-helmet';

// Assets
import serverArtwork from '../assets/artwork/ServerArtwork.png';

// Components
import CtaBtn from '../components/CtaBtn';
import Footer from '../components/Footer';
import BtnContainer from '../components/BtnContainer';
import Modal from '../components/Modal';
import Navbar from '../components/Navbar';
import ServiceCards from '../components/ServiceCards';
import ctaBtn from '../components/CtaBtn';

class Services extends Component {
    state = {
        showModal: "none",
        displayMobile: "none"
      }
    
    componentDidMount(){
        window.addEventListener('scroll', this.showText);
        window.addEventListener('scroll', this.showServiceCards);
    }

    componentWillUnmount() {
        window.removeEventListener('scroll', this.showText);
        window.removeEventListener('scroll', this.showServiceCards);
    }

    showText() {
        const presenceText = document.getElementById('presenceText');
        const processesText = document.getElementById('processesText');
        if (window.scrollY > 150 && presenceText.classList.contains("invisible")){
            presenceText.classList.add("visible");
            processesText.classList.add("visible");
            presenceText.classList.remove("invisible");
            processesText.classList.remove("invisible");
    };}

    showServiceCards() {
        const ServiceCards = document.getElementsByClassName('ServiceCard');
        const condition = ServiceCards.length -1;
        if (window.scrollY > 700 && ServiceCards[condition].classList.contains('invisible')){
            for (let i=0; i < ServiceCards.length; i++){
                setTimeout(function(){
                    if(typeof(ServiceCards[i])==="undefined"){
                        return null;
                    }
                    else {
                        ServiceCards[i].classList.add("visible");
                        ServiceCards[i].classList.remove("invisible");
                    }
                },
                i*150)
            }
    }}
    
    toggleModal = () => {
    if (this.state.showModal === "none") {
        this.setState({
            showModal: "block"
        })
        window.scrollTo(0,0);
    }
    else {
        this.setState({
            showModal: "none"
        })
    }
    }

    toggleMobileMenu = () => {
        if (this.state.displayMobile === "none") {
            this.setState({
              displayMobile: "flex"
            })
        }
        else {
            this.setState({
              displayMobile: "none"
            })
        }
      }


    render() {
        return(
                <div className="ServicesPage">
                <Helmet>
                    <title>Our Services | Candid Goat: Tech Solutions for Small Businesses</title>
                    <meta name="description" content="From websites and SEO to CRMs and project management apps, Candid Goat delivers custom tech solutions for small businesses." />
                </Helmet>
                <Modal showModal={this.state.showModal} click={this.toggleModal} />
                <Navbar click={this.toggleModal} displayMobile={this.state.displayMobile} mobileMenu={this.toggleMobileMenu} />
                <div className="grayServices navbarNeighbor" id="servicesScroll">
                    <div className="servicesHero noPadding">
                        <h1 className="titleFont centerText boldest">Digital Presence + Processes</h1>
                        <p className="bodyFont centerText container width-12">We don't believe in a one-size-fits-all approach. Each solution we deliver is tailored to your unique business needs and is as comprehensive as you want it to be.</p>
                        <div className="flexRow alignStart">
                            <div className="width-5 flexEnd noPadding">
                                <div className="presenceBox centerText">
                                    <h2 className="titleFont">Presence is...</h2>
                                    <p className="bodyFont invisible" id="presenceText">what you provide to the outside world. We can handle your website, UX, SEO,  social media, and pretty much anything else you need to create your own digital space online.</p>
                                </div>
                            </div>
                            <div className="serverWrapper flexColumn width-2 noPadding">
                                <img src={serverArtwork} alt="Candid Goat Server"/>
                            </div>
                            <div className="width-5 flexStart noPadding">
                                <div className="processesBox centerText turnBlack">
                                    <h2 className="titleFont turnBlack">Processes are...</h2>
                                    <p className="bodyFont turnBlack invisible" id="processesText">about facilitating your internal world. Whether it’s internal apps, CRM, or project management, we provide you with hassle free tools that work so you can work, clean and simple.</p>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="servicesContainer">
                        <h2 className="titleFont bold">Some of the solutions we deliver...</h2>
                        <ServiceCards cardList={[ "React", "Hubspot", "Trello", "WordPress", "Google Search Console",
                        "SciKit", "Joomla", "Bing Webmaster", "Google Data Studio", "Zapier",
                        "Insightly", "Numpy", "MongoDB", "Asana",
                        "Infor CRM", "Nodejs", "Hootsuite", "And More..."]} />
                    </div>
                </div>
                <BtnContainer btnType={CtaBtn} click={this.toggleModal} content="We provide a complete solution for all your digital needs."/>
                <footer>
                    <Footer />
                </footer>
                </div>
        )
    }
}

export default Services;


// WEBPACK FOOTER //
// ./src/pages/Services.js